<template>
  <div class="video-parent-result">
    <img
      :src="getParentInstructorPicture"
      class="video-parent-result__parent-instructors-img"
      :alt="contentInstructors"
    />
    <div class="video-parent-result__parent-title-wrapper">
      <router-link
        :to="
          $buildContentLink(parentTypeToMatchRoutes, {
            ...parent,
            id: parent.objectID,
          })
        "
        class="video-parent-result__link"
      >
        <h3 class="video-parent-result__parent-title">
          {{ parent.name || '' }}
        </h3>
      </router-link>
      <div
        class="video-parent-result__circles"
        v-for="larea in parent.learning_areas"
        :key="larea.id"
      >
        <span
          v-tooltip="{
            content: `${larea.name}`,
            placement: 'top-center',
          }"
          class="video-parent-result__circle"
          :style="`background: ${getLAreaColor(larea)}`"
        ></span>
      </div>
      <Active
        v-if="parentType === 'course'"
        :course="parent"
        class="video-parent-result__activator"
      />
    </div>
    <p class="video-parent-result__parent-instructors">
      with {{ contentInstructors }}
    </p>
  </div>
</template>

<script>
import Active from '@/components/properties/Active.vue'
import CONSTANTS from '@/constants'
import { bootcampCommons } from '@/helpers/mixins'

export default {
  name: 'VideoParentResult',
  components: {
    Active,
  },
  mixins: [bootcampCommons],
  props: {
    parent: {
      type: Object,
      required: true,
    },
    parentType: {
      type: String,
      required: true,
    },
  },
  data: () => {
    return {
      parents: CONSTANTS.SEARCH.PARENTS,
    }
  },
  computed: {
    getParentInstructorPicture() {
      return this.parent.instructors[0].profile_img_url
        ? this.parent.instructors[0].profile_img_url
        : require('@/assets/images/instructor_fallback.png')
    },
    parentTypeToMatchRoutes() {
      return this.parentType === 'learning_path' ? 'path' : this.parentType
    },
  },
  methods: {
    getLAreaColor(larea) {
      return CONSTANTS.LEARNING_AREAS.COLORS[larea.id]
    },
  },
}
</script>

<style lang="scss" scoped>
.video-parent-result {
  display: flex;
  flex-wrap: wrap;
  display: block;
  position: relative;
  width: 100%;
  &__parent-title {
    color: var(--white);
    font-size: rem(20px);
    font-weight: bold;
    margin: 0 30px 0px 100px;
    line-height: 150%;
    margin-bottom: 10px;
  }
  &__parent-title-wrapper {
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;
  }
  &__activator {
    margin-left: auto;
  }
  &__parent-instructors {
    color: var(--white);
    margin: 0 0 30px 103px;
  }
  &__parent-instructors-img {
    max-height: 70px;
    border-radius: 70px;
    position: absolute;
    left: 20px;
    top: 0;
    max-width: 70px;
  }
  &__circles {
    padding-top: 10px;
  }
  &__circle {
    width: 15px;
    height: 15px;
    display: block;
    border-radius: 50%;
  }
}
</style>
